import React, {useEffect, useState} from "react";
import {calculatePerPageOptions, isDefined, range} from "../../utils/utils";
import I18n from "i18n-js";


export const ItemsPerPageSelector = ({
  perPage,
  perPageOptions,
  handleChangePageOrPerPage
}) => {

  return (
    <React.Fragment>
      <p>
        {I18n.t('js.editSubmissionListPage.itemsPerPage')}
      </p>

      <div className="ml-2 pb-2">
        <select
          className="form-control p-0 submission-list-custom-select cursor-pointer"
          value={perPage}
          name="perPageSelector"
          id="perPageSelector"
          onChange={(e) => handleChangePageOrPerPage(1, e.target.value)}
        >
          {perPageOptions.map(per_page => {
            return <option value={per_page} key={per_page}>
              { per_page }
            </option>
          })}
        </select>
      </div>
    </React.Fragment>
  );
}



const Paginator = ({
  itemsCount,
  handleChangePage,
  items,
  setItems,
  onPageChange
}) => {

  const [ page, setPage ] = useState(1);
  const [ perPageOptions, setPerPageOptions ] = useState(calculatePerPageOptions(itemsCount))
  const [ perPage, setPerPage ] = useState(null);
  const [ pagesCount, setPagesCount ] = useState(1);

  useEffect(() => {
    if (!perPage)
      setPerPage(perPageOptions[0])
  }, [perPageOptions]);

  useEffect(() => {
    if (perPage)
      setPagesCount(Math.ceil(itemsCount / perPage));
  }, [perPage])

  useEffect(() => {
    if (!handleChangePage)
      setItems(items.slice(perPage * (page - 1), page * perPage));
  }, [page, perPage])


  const handleChangePageOrPerPage = (newPage, newPerPage) => {
    if (handleChangePage)
      handleChangePage();
    if (onPageChange)
      onPageChange();
    setPage(newPage);
    if (isDefined(newPerPage))
      setPerPage(newPerPage);
  }


  return (
    <React.Fragment>
      {
        isDefined(perPageOptions) && itemsCount > perPageOptions[0] && perPage &&
        <React.Fragment>
          <div className="d-flex justify-content-end align-items-baseline">
            <div className="d-none d-sm-flex align-items-center">
              <ItemsPerPageSelector
                perPage={perPage}
                perPageOptions={perPageOptions}
                handleChangePageOrPerPage={handleChangePageOrPerPage}
              />
            </div>

            <div className="d-flex border-bottom-radius-8px border-left-solid border-bottom-solid border-right-solid ml-4 mb-3" id="page-indexes-container">
              {
                pagesCount > 1 &&
                (
                  range(1, pagesCount, 1).map(pageNumber => {
                    return (
                      <div id={`page_${pageNumber}`} key={`page_${pageNumber}`}
                           className={`page-index d-flex align-items-center justify-content-center cursor-pointer 'border-left-solid 
                                ${pageNumber === 1 ? 'border-bottom-left-radius-8px' : ''} ${pageNumber === pagesCount ? 'border-bottom-right-radius-8px' : ''} 
                                ${pageNumber > 1 ? 'border-left-solid' : ''} ${pageNumber === page ? 'bg-aig-gradient' : ''}`}
                           onClick={() => handleChangePageOrPerPage(pageNumber, null)}
                      >
                        <b className={`${pageNumber === page ? 'text-white' : 'text-black-imp'}`}>
                          {pageNumber}
                        </b>
                      </div>
                    )
                  })
                )
              }
            </div>
          </div>

          <div className="d-flex d-sm-none justify-content-end align-items-center">
            <ItemsPerPageSelector
              perPage={perPage}
              perPageOptions={perPageOptions}
              handleChangePageOrPerPage={handleChangePageOrPerPage}
            />
          </div>
        </React.Fragment>
      }
    </React.Fragment>
  );
};

export default Paginator;